/**
 * Created by swandelow on 09/03/18.
 */
import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import * as angular from 'angular';
import {LogoutComponent} from "./logout.component";

/*
 * Workaround para que siga funcionando la configuración
 * $routeProvider.otherwise() que redirige a la pantalla de error
 * cuando se ingresan URLs desconocidas.
 * */
angular.module('CarsSaraBo')
    .config(['$routeProvider', ($routeProvider) => {
        $routeProvider.when('/logout', {template: ''});
    }]);
/***/

const logoutRoutes: Routes = [
    {path: 'logout', component: LogoutComponent},
    {path: 'cars-sara-v2/web/logout', component: LogoutComponent}
];

@NgModule({
    imports: [
        RouterModule.forChild(logoutRoutes)
    ],
    exports: [
        RouterModule
    ]
})
export class LogoutRoutingModule {
}


// WEBPACK FOOTER //
// ./public/upgrade/feature/logout/logout-routing.module.ts